import styles from "./demandDetail.module.css"
import MultiStageProgress from "../../../components/multistageProgress/MultiStageProgress";
import IMAGES from "../../../assets/images/images";
import ServiceDetail from "../template/serviceDetailTemplate/serviceDetail";
import { Container } from "../../../components/Container/Containers";
import { useNavigate, useParams } from "react-router-dom";
import DemandReview from "../template/demandReviewTemplate/demandReview";
import { useEffect, useMemo, useRef, useState } from "react";
import ConfirmationModal from "../template/confirmationPopupTemplate/confirmationPopup";
import StatusCallout, { ReportIndicatorPanel, ProgressIndicator } from "../template/progressTemplate/progressIndicator";
import AddComment from "../template/AddComment/addComment.container";
import FeasibilityForm from "../template/feasibilityCheckTemplate/feasibilityCheck.container";
import Quotation from "../template/quotationTemplate/Quotation";
import OrderForm from "../template/orderForm/OrderForm";
import { buildProgressFromStates, formatDateInDMY, has, hasAny, isStateValid } from "../../../utils/arrayUtils";
import { ACTION_STATUS, DEMAND_ACTIONS, EMAIL_DELIVERY_STATUS, initialValues, orderFormInitialValues, QUOTATION_STATUS, Quotation_SUBTAB, WORKFLOW_STAGES } from "../../../utils/constants/DemandConstant";
import { FUNCTIONAL_ROLES_CONSTANTS, USER_TYPE } from "../../../utils/constants/userConstants";
import { SubTabs } from "../../../components/tabs/subtabs";
import Shimmer from "../../../components/shimmer/Shimmer";
import LegalContract from "../template/legalContractTemplate/legalContract";
import { Submit } from "../../../components/button/buttons";
import ServiceProvisioning from "../template/serviceProvisioningTemplate/serviceProvisioning";
import Billing from "../template/billingTemplate/billing";
import CAN from '../../../casl/can';
import { Action, Resource } from '../../../casl/constants';
import SectionGuard from "../../../hoc/guards/SectionGuard";
import { demandAction } from "../../../api/demand/demand.service";
import { buildRegionCountryOptions } from "../template/addDemandTemplate/demandHelper";
import { ConfirmDialog } from "../../../hooks/confirmDialog/confirmDialog";
import DemandClosurePopup from "../template/demandClosurePopup/demandClosurePopup";
import EmailTrigger from "../template/emailTriggerTemplate/emailTrigger";

const DemandDetail = ({ demandDetail: demandDetailFromStore, ...props }) => {

  const navigate = useNavigate();
  let { requestId } = useParams();
  const targetRef = useRef(null);
  const [isDownloadStart, setIsDownloadStart] = useState(false);
  const [isloading, setIsLoading] = useState(false);  // demand action loading
  const [isSubmit, setIsSubmit] = useState(null);
  const [selectedStage, setSelectedStage] = useState(null)
  const [selectedStageIndex, setSelectedStageIndex] = useState(null)
  const [workflowStages, setWorkflowStages] = useState([])
  const [isActiveDemand, setIsActiveDemand] = useState(false)  // demand is active if its not closed and complete
  const [floorPriceActiveData, setFloorPriceActiveData] = useState({});
  const [quotationActiveData, setQuotationActiveDataData] = useState({});
  const [orderFormActiveData, setOrderFormActiveData] = useState({});
  const [quotationRevisionData, setQuotationRevisionData] = useState([]);
  const [floorPricingRevisionData, setFloorPricingRevisionData] = useState([]);
  const [demandClosure, setDemandClosure] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const [isEditServiceDate, setIsEditServiceDate]=useState(false);

  const stageData = demandDetailFromStore?.stageData ?? {};
  const feasibilityActive = stageData?.feasibility?.active ?? {};
  const orderFormCustomerSignedActive = stageData?.orderFormCustomerSigned?.active ?? {};
  const orderFormLegalContractActive = stageData?.orderFormLegalContract?.active ?? {};
  const serviceProvisioningActive = stageData?.serviceProvisioning?.active ?? {};
  const billingActive = stageData?.billing?.active ?? {};

  const LEGAL_CONTRACT_VISIBLE_STAGE = [
    WORKFLOW_STAGES.ORDER_FORM,
    WORKFLOW_STAGES.SERVICE_BUILDING,
    WORKFLOW_STAGES.BILLING_ONBOARDING,
    WORKFLOW_STAGES.GO_LIVE,
  ].filter((stage) =>
    props?.myRights?.functionalRoles[0] ===
      FUNCTIONAL_ROLES_CONSTANTS.engineering_or_technology_internal?.value
      ? stage !== WORKFLOW_STAGES.ORDER_FORM
      : true
  );

  let descriptionNote = demandDetailFromStore?.statusNote?.message;
    
    //  (demandDetailFromStore?.stageData?.billing?.active?.canConfirmServiceActivationDate === true ||   ----- As of now we are showing same message in both condition true or false so no need of this condition.
    // demandDetailFromStore?.stageData?.billing?.active?.canConfirmServiceActivationDate === false ) &&

  const isBillingOnboardingCompleted =
    demandDetailFromStore?.stageData?.billing?.active?.canEditServiceActivationDate === false &&
    demandDetailFromStore?.actionStatus === ACTION_STATUS.BILLING_ONBOARDING_COMPLETED;
  
  if (isBillingOnboardingCompleted) {
    if (props?.myRights?.userType === USER_TYPE.CUSTOMER) {
      descriptionNote = "We are ready for service Go-Live. The 'Service Start Date' below indicates when your service will go live and billing will begin.";
    } else if (CAN(Action.COMPLETE_DEMAND, Resource.D2C_DEMANDS)) {
      descriptionNote = "The Service Start Date has been shared with the customer. The service will go live on the specified date, and we will notify you once the service is successfully activated.  ";
    }
  }

  const InfoTemplate = ({ note }) => {
    return (
      <div className={styles.infoTemplate}>{note?.split("\n")?.map(item => <div>{item}</div>)}</div>
    )
  }
  const regionCountryOptions = useMemo(() => {
    return buildRegionCountryOptions(props.locations);
  }, [props.locations]);


  function isEmptyObject(obj) {
    return (
      !obj ||
      typeof obj !== "object" ||
      Array.isArray(obj) ||
      Object.keys(obj).length === 0
    );
  }


  const regionOptions = [{ value: "", label: "Please Select" }, ...regionCountryOptions?.regionList];

  const subTabOptions = [
    {
      key: Quotation_SUBTAB.FEASIBILITY,
      label: "Feasibility Assessment",
      canAccess: CAN(Action.GET_FEASIBILITY_DETAILS, Resource.D2C_DEMANDS) || CAN(Action.DOWNLOAD_FEASIBILITY_REPORT, Resource.D2C_DEMANDS) || CAN(Action.CREARE_FEASIBILITY, Resource.D2C_DEMANDS)
    },
    {
      key: Quotation_SUBTAB.FLOOR_PRICING,
      label: "Floor Pricing",
      canAccess: CAN(Action.CREARE_FLOORPRICING, Resource.D2C_DEMANDS) || CAN(Action.GET_FLOORPRICE_DETAILS, Resource.D2C_DEMANDS)
    },
    {
      key: Quotation_SUBTAB.QUOTATION,
      label: "Quotation",
      canAccess: CAN(Action.CREATE_ADD_MARGIN, Resource.D2C_DEMANDS) || CAN(Action.GET_QUOTATION_DETAILS, Resource.D2C_DEMANDS)
    }
  ]

  const getDefaultActiveTab = (actionStatus) => {
    if (actionStatus == ACTION_STATUS.INITIATE_FISIBILITY || actionStatus == ACTION_STATUS.FEASIBILITY_COMPLETED) {
      return Quotation_SUBTAB.FEASIBILITY;
    } else if (actionStatus == ACTION_STATUS.QUOTATION_FLOOR_PRICING_INITIATED) {
      return Quotation_SUBTAB.FLOOR_PRICING
    } else if (actionStatus == ACTION_STATUS.QUOTATION_MARGIN_INITIATED || actionStatus == ACTION_STATUS.QUOTATION_CUSTOMER_APPROVAL_INITIATED) {
      return Quotation_SUBTAB.QUOTATION
    } else {
      return Quotation_SUBTAB.FEASIBILITY;
    }
  };

  const getSubActiveTab = (tab) => {
    props.setActiveSecondaryTab(tab);
  }

  const back = () => {
    navigate(-1);
    // navigate(`/connectivity/demands`);
  }

  const handleSend = async (btnaction) => {
    const nextStatus = btnaction === "serviceBuilding" ? DEMAND_ACTIONS.INITIATE_PROVISIONING : DEMAND_ACTIONS.COMPLETE_DEMAND
    let stateData={}

    const ok = await ConfirmDialog(nextStatus);
    if (!ok.confirmed) return false

    if(btnaction==="serviceActivationDateAcknowledge"){
      const actionComment=ok?.comment.trim()  // if confirmed
      stateData={actionComment:actionComment}
    }
    setIsSubmit(btnaction)
    try {
      const payload = { action: nextStatus, stateData: stateData }
      const res = await props?.addDemandAction(payload, requestId);
      if (!res) {
        props.openAlertPopup({
          message: "Unable to process. Please try again.",
          image: IMAGES.error,
        });
        return;
      }
      if(res){
        handelServiceDetailapi();
      }
      props.openAlertPopup({
        message: btnaction === "serviceBuilding"?"Service Build Initiated Successfully.":"Demand Completed Successfully.", 
        image: IMAGES.success,
      });
    } catch (error) {
      props?.openAlertPopup({
        message:"An error occurred while processing your request. Please try again later.",
        image: IMAGES.error,
      });
    } finally { setIsSubmit(null); }
  }

  const scrollToSection = () => {
   setActiveTab("commentTab")
    const offset = 50;
    const element = targetRef.current;
    const topPos = element.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: topPos - offset,
      behavior: "smooth"
    });
  };

  const onFileDownload = (file) => {
    setIsDownloadStart(true);
    props.downloadFile(file.originalFileName, file.uniqueFileName).then((result) => {
      if (result.status) {
      } else {
        props.showAlertPopup({ alertHeader: "Alert" }, { alertMessage: "Error while downloding file!" });
      }
      setIsDownloadStart(false);
    }).catch((error) => {
      props.showAlertPopup({ alertHeader: "Alert" }, { alertMessage: "Error while downloding file!" });
      setIsDownloadStart(false);
    })
  }

  const handelServiceDetailapi = () =>{
    if (CAN(Action.GET, Resource.DEMANDS)) {
      props.getServiceDetail(requestId)
      .then(() => {})
        .catch((error) => {
          props?.openAlertPopup({
            message: "An error occurred while processing your request. Please try again later.",
            image: IMAGES.error
          });
        });
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    handelServiceDetailapi();
    props.getLocations();
  }, []);

  useEffect(() => {
    const formattedStages = buildProgressFromStates(demandDetailFromStore?.mappedStates || [], demandDetailFromStore.state, demandDetailFromStore?.actionStatus,demandDetailFromStore?.stageData?.closed || {})
    setWorkflowStages(formattedStages);
    const activeStageIndex = formattedStages?.findIndex((s) => s.isActive)
    const activeStage = formattedStages[activeStageIndex]?.label
    // setSelectedStageIndex(activeStageIndex);
    setSelectedStage(activeStage)
    const isActiveDemand = ![ACTION_STATUS.DEMAND_CLOSED,ACTION_STATUS.DEMAND_CLOSED_BY_SYSTEM, ACTION_STATUS.DEMAND_COMPLETED].includes(demandDetailFromStore.actionStatus)
    setIsActiveDemand(isActiveDemand)


    if (props?.myRights?.userType === USER_TYPE.CUSTOMER) {
      props.setActiveSecondaryTab(Quotation_SUBTAB.QUOTATION)
    } else if (CAN(Action.GET_FEASIBILITY_DETAILS, Resource.D2C_DEMANDS || Action.CREARE_FEASIBILITY, Resource.D2C_DEMANDS) &&
      !CAN(Action.GET_FLOORPRICE_DETAILS, Resource.D2C_DEMANDS) &&
      !CAN(Action.GET_QUOTATION_DETAILS, Resource.D2C_DEMANDS)) {
      props.setActiveSecondaryTab(Quotation_SUBTAB.FEASIBILITY);
    } else if (!CAN(Action.GET_FEASIBILITY_DETAILS, Resource.D2C_DEMANDS) &&
      !CAN(Action.GET_FLOORPRICE_DETAILS, Resource.D2C_DEMANDS) &&
      !CAN(Action.GET_QUOTATION_DETAILS, Resource.D2C_DEMANDS)) {
      props.setActiveSecondaryTab(null);
    } else {
      const activeTab = getDefaultActiveTab(demandDetailFromStore.actionStatus)
      props.setActiveSecondaryTab(activeTab);
    }

    const floorPriceActive = demandDetailFromStore?.stageData?.floorPricing?.active || {};
    const quotationActive = demandDetailFromStore?.stageData?.quotations?.active || {};
    const orderFormActive = demandDetailFromStore?.stageData?.orderForm?.active || {};
    setQuotationRevisionData(demandDetailFromStore?.stageData?.quotations?.revisions || []);
    setFloorPricingRevisionData(demandDetailFromStore?.stageData?.floorPricing?.revisions || []);

    let nextFloor = {};
    let nextQuote = {};
    let nextOrderform = {};
    if (demandDetailFromStore?.actionStatus === ACTION_STATUS.QUOTATION_FLOOR_PRICING_INITIATED && isEmptyObject(floorPriceActive) && CAN(Action.CREARE_FLOORPRICING, Resource.D2C_DEMANDS)) {
      nextFloor = { ...initialValues, customerLegalName: demandDetailFromStore?.organisationName || "" };
    } else if (floorPriceActive) {
      nextFloor = floorPriceActive;
    }

    if (demandDetailFromStore?.actionStatus === ACTION_STATUS.QUOTATION_MARGIN_INITIATED && ( isEmptyObject(quotationActive) || quotationActive?.status===QUOTATION_STATUS.EXPIRED )  && CAN(Action.CREATE_ADD_MARGIN, Resource.D2C_DEMANDS)) {
      nextQuote = floorPriceActive ?? {}; // if floorPriceActive exists, reuse; else null
    } else if (quotationActive) {
      nextQuote = quotationActive;
    }

    if (demandDetailFromStore?.actionStatus === ACTION_STATUS.ORDER_FORM_CREATION_INITIATED && isEmptyObject(orderFormActive)  && CAN(Action.CREATE_DRAFT_ORDER_FORM, Resource.D2C_DEMANDS)) {
      nextOrderform = { ...orderFormInitialValues(demandDetailFromStore?.organisationName, demandDetailFromStore?.accountManagers) };
    } else if (quotationActive) {
      nextOrderform = orderFormActive;
    }
    setFloorPriceActiveData(nextFloor);
    setQuotationActiveDataData(nextQuote);
    setOrderFormActiveData(nextOrderform)


  }, [demandDetailFromStore])




  return (
    props.isLoading ? <div className={styles.shimmeContainer}><Shimmer /></div> :
      <SectionGuard canAccess={CAN(Action.GET, Resource.DEMANDS)}>
        <Container>
          <div className={styles.wrapper}>
            <div className={styles.demandheader}>
              <div className={styles.demandid}>
                <span><img className={styles.backbutton} src={IMAGES.backarrow} onClick={back} alt="backImage" /></span>
                <span className={styles.id}>{demandDetailFromStore?.requestId}</span>
              </div>
              <div className={styles.rightpart}>
                 {isActiveDemand && (
                  CAN(Action.CLOSER, Resource.D2C_DEMANDS) && (
                    <div className={styles.btnCancel} onClick={() => setDemandClosure(true)} >Cancel Demand</div>
                  ))}
                <SectionGuard canAccess={
                  isActiveDemand &&
                  (
                    CAN(Action.CREATE_COMMENT, Resource.DEMANDS) ||
                    demandDetailFromStore.actionStatus == ACTION_STATUS.FEASIBILITY_INITIATED && CAN(Action.CREATE_FEASIBILITY_COMMENTS, Resource.D2C_DEMANDS) ||
                    demandDetailFromStore.actionStatus == ACTION_STATUS.PROVSIONING_INITIATED && CAN(Action.CREATE_PROVISIONING_COMMENTS, Resource.D2C_DEMANDS)
                  )
                }>
                  <span className={styles.btnqna} onClick={scrollToSection}>Add Comment</span>
                </SectionGuard>
              </div>
            </div>
            <div className={styles.stages}>
              <MultiStageProgress
                workflowStages={workflowStages || []}
                selectedStageIndex={selectedStageIndex}
                onStatePick={({ selectedStage, selectedStageIndex }) => {
                  setSelectedStageIndex(selectedStageIndex);
                  setSelectedStage(selectedStage)
                }}
              />
            </div>
            <ServiceDetail data={demandDetailFromStore} onFileDownload={onFileDownload} />
            {/* {props?.myRights?.userType === USER_TYPE.CUSTOMER && demandDetailFromStore?.userActionFlag?.comment?.isActionRequired==true &&
                                           ![ ACTION_STATUS.DEMAND_CLOSED,ACTION_STATUS.DEMAND_CLOSED_BY_SYSTEM,ACTION_STATUS.DEMAND_COMPLETED]
                                           .includes(demandDetailFromStore?.actionStatus) &&(
              <div className={styles.actionNote}>
                <img className={styles.messageActionIcon} src={IMAGES.messageActionIcon}/>
                <div className={styles.actiontxt}>Please provide the requested information to help us process your demand.</div>
              </div>
            )} */}
            {
              demandDetailFromStore?.statusNote?.status && (
                <StatusCallout
                  sectionHelpText="This section summarizes the current state of the demand."
                  title={demandDetailFromStore?.statusNote?.status}
                  description={descriptionNote}
                  icon={IMAGES.attachmenticon}
                />
              )
            }
            { demandDetailFromStore?.stageData?.closed?.comment &&
               <StatusCallout
                  title={"Cancellation Reason"}
                  description={demandDetailFromStore?.stageData?.closed?.comment}
                  classStyle={styles.cancelReason}
                />
            }
            {demandDetailFromStore?.stageData?.completed?.active?.actionComment &&
               <StatusCallout
                  title={"Final Remarks"}
                  description={demandDetailFromStore?.stageData?.completed?.active?.actionComment}
                  classStyle={styles.cancelReason}
                />
            }
            {
              selectedStage == WORKFLOW_STAGES.QUOTATION && (
                subTabOptions.filter(tab => tab.canAccess === true).length > 1 ?
                  <div className={styles.wrapper}>
                    <SubTabs option={subTabOptions} defaultActiveTab={getDefaultActiveTab(demandDetailFromStore.actionStatus)} getSubActiveTab={getSubActiveTab} />
                  </div>
                  : <></>
              )
            }
          </div>
          <div className={styles.panelArea}>
            {
              selectedStage == WORKFLOW_STAGES.DEMAND && (
                <>
                  {
                    demandDetailFromStore?.actionStatus === ACTION_STATUS.REVIEW_INITIATED &&
                    CAN(Action.REVIEW_DEMAND, Resource.D2C_DEMANDS) &&
                    (
                      <DemandReview
                        actionStatus={demandDetailFromStore.actionStatus}
                        requestId={requestId}
                        handelServiceDetailapi={handelServiceDetailapi}
                      />
                    )
                  }
                </>
              )
            }
            {
              selectedStage == WORKFLOW_STAGES.QUOTATION && (
                <>
                  {
                    props.activeSecondaryTab === Quotation_SUBTAB.FEASIBILITY && (
                      <>
                        {
                          !isEmptyObject(feasibilityActive) &&
                          CAN(Action.GET_FEASIBILITY_DETAILS, Resource.D2C_DEMANDS) && (
                            feasibilityActive?.isFeasibilityCheckRequired === false ?
                              <InfoTemplate note={feasibilityActive?.comment} /> :
                              <ReportIndicatorPanel
                                text={"Please click the 'Download' button to review and download the feasibility assessment report."}
                                type={null}
                                data={feasibilityActive}
                                onFileDownload={onFileDownload}
                                downloadAccess={CAN(Action.DOWNLOAD_FEASIBILITY_REPORT, Resource.D2C_DEMANDS)} />
                          )
                        }
                        {
                            demandDetailFromStore?.actionStatus === ACTION_STATUS.FEASIBILITY_INITIATED &&
                            CAN(Action.CREARE_FEASIBILITY, Resource.D2C_DEMANDS) ?
                            <FeasibilityForm getServiceDetail={props.getServiceDetail} /> :
                            demandDetailFromStore?.actionStatus === ACTION_STATUS.FEASIBILITY_INITIATED &&
                              CAN(Action.GET_FEASIBILITY_DETAILS, Resource.D2C_DEMANDS) ?
                              <InfoTemplate note={"Feasibilty report has not been shared yet.\nYou will be able to view the Feasibilty report here once it is available."} /> : <></>
                        }
                      </>
                    )
                  }
                  {
                    props.activeSecondaryTab === Quotation_SUBTAB.FLOOR_PRICING && (
                      <>
                        {
                          demandDetailFromStore?.actionStatus === ACTION_STATUS.FEASIBILITY_COMPLETED &&
                            CAN(Action.REVIEW_DEMAND, Resource.D2C_DEMANDS) ?
                            <DemandReview
                              actionStatus={demandDetailFromStore.actionStatus}
                              requestId={requestId}
                              handelServiceDetailapi={handelServiceDetailapi}
                            />
                            :
                            isEmptyObject(floorPriceActiveData) && CAN(Action.GET_FLOORPRICE_DETAILS, Resource.D2C_DEMANDS) ?
                              <InfoTemplate note={"Floor Price has not been created yet.\nYou will be able to view the Floor Price here once it is available."} />
                              :
                              !isEmptyObject(floorPriceActiveData) &&
                                (CAN(Action.GET_FLOORPRICE_DETAILS, Resource.D2C_DEMANDS) || CAN(Action.CREARE_FLOORPRICING, Resource.D2C_DEMANDS)) ?
                                <Quotation
                                  historyData={floorPricingRevisionData}
                                  actionStatus={demandDetailFromStore?.actionStatus}
                                  quotationData={floorPriceActiveData}
                                  regionOptions={regionOptions}
                                  handelServiceDetailapi={handelServiceDetailapi}
                                />
                                : <></>
                        }
                      </>
                    )
                  }
                  {
                    props.activeSecondaryTab === Quotation_SUBTAB.QUOTATION && (
                      <>
                        {
                          isEmptyObject(quotationActiveData) && CAN(Action.CREATE_ADD_MARGIN, Resource.D2C_DEMANDS) ?
                            <InfoTemplate note={"Quotation preparation will be enabled once the floor pricing is submitted. You will be notified when it becomes available.\nPlease wait until this step is completed."} /> :
                            isEmptyObject(quotationActiveData) && CAN(Action.GET_QUOTATION_DETAILS, Resource.D2C_DEMANDS) ?
                              <InfoTemplate note={"Quotation has not been created yet.\nYou will be able to view the quotation here once it is prepared and shared. An email notification will be sent once it is available."} /> :
                              !isEmptyObject(quotationActiveData) &&
                                (CAN(Action.GET_QUOTATION_DETAILS, Resource.D2C_DEMANDS) || CAN(Action.CREATE_ADD_MARGIN, Resource.D2C_DEMANDS)) ?
                                <Quotation
                                  historyData={quotationRevisionData}
                                  actionStatus={demandDetailFromStore?.actionStatus}
                                  quotationData={quotationActiveData}
                                  floorPriceActiveData={floorPriceActiveData}
                                  regionOptions={regionOptions}
                                  handelServiceDetailapi={handelServiceDetailapi}
                                />
                                : <></>
                        }
                      </>
                    )
                  }
                </>
              )
            }
            {
              !isEmptyObject(orderFormCustomerSignedActive) && LEGAL_CONTRACT_VISIBLE_STAGE.includes(selectedStage)
              && CAN(Action.GET_SIGNED_ORDERFORM_DETAILS, Resource.D2C_DEMANDS)
              && CAN(Action.DOWNLOAD_SIGNED_ORDERFORM, Resource.D2C_DEMANDS) && orderFormLegalContractActive.isLegalContractUploaded !== true && (
                <ReportIndicatorPanel
                  text={"Please click the 'Download' button to review and download the customer signed order form."}
                  detailData={demandDetailFromStore}
                  data={orderFormCustomerSignedActive}
                  onFileDownload={onFileDownload}
                  downloadAccess={CAN(Action.DOWNLOAD_SIGNED_ORDERFORM, Resource.D2C_DEMANDS)}/>
              )
            }
            {
              !isEmptyObject(orderFormLegalContractActive) && orderFormLegalContractActive.isLegalContractUploaded === true &&
              LEGAL_CONTRACT_VISIBLE_STAGE.includes(selectedStage) &&
              CAN(Action.GET_ORDERFORM_LEAGAL_CONTARCT_DETAILS, Resource.D2C_DEMANDS) &&
              <ReportIndicatorPanel
                text={"Please click the 'Download' button to review and download the duly signed order form."}
                data={orderFormLegalContractActive}
                onFileDownload={onFileDownload}
                downloadAccess={CAN(Action.DOWNLOAD_LEGAL_CONTRACT, Resource.D2C_DEMANDS)}
              />
            }
             {
              selectedStage == WORKFLOW_STAGES.BILLING_ONBOARDING && (
                <>
                  {
                    !isEmptyObject(billingActive) &&
                    billingActive?.serviceStartDate &&
                    CAN(Action.GET_BILLING_DETAILS, Resource.D2C_DEMANDS) && (
                      <div className={styles.actionContainer}>
                        {props?.myRights?.userType === USER_TYPE.CUSTOMER ?
                          <div className={styles.acknowledgeContainer}>
                            {demandDetailFromStore?.actionStatus === ACTION_STATUS.DEMAND_COMPLETED ? <div className={`${styles.acktxt} ${styles.stardate}`}>Service Start Date:</div> : <>
                              <div className={`${styles.acktxt} ${styles.stardate}`}>The 'Service Start Date' shared by the Vodafone team is shown below -</div>
                              <div className={`${styles.acksubtxt} `}>Please review the 'Service Start Date' below, as billing will commence from this date.
                                <br />For any concerns or queries, please contact your Vodafone Account Manager at least five (5) days prior to the 'Service Start Date'.</div></>}
                            <div className={styles.ackdate}>{formatDateInDMY(billingActive?.serviceStartDate)}</div>
                          </div> :
                          <div className={styles.acknowledgeContainer}>
                            {
                              CAN(Action.CREATE_BILLING, Resource.D2C_DEMANDS) &&
                              demandDetailFromStore.actionStatus === ACTION_STATUS.BILLING_ONBOARDING_COMPLETED &&
                                isEditServiceDate &&
                                billingActive?.canEditServiceActivationDate == true && billingActive?.canConfirmServiceActivationDate == false ?
                                <Billing
                                  handelServiceDetailapi={handelServiceDetailapi}
                                  billingData={billingActive}
                                  actionStatus={ACTION_STATUS.BILLING_ONBOARDING_COMPLETED}
                                  isEditServiceDate={isEditServiceDate}
                                  onToggleScreen={() => setIsEditServiceDate(false)}
                                /> :
                                <>
                                  <div className={`${styles.acktxt} ${styles.stardate}`}>{demandDetailFromStore?.actionStatus === ACTION_STATUS.DEMAND_COMPLETED ? "The confirmed 'Service Start Date' is:" : "Below Service Start Date has been shared with the customer:"}</div>
                                  <div className={styles.ackdate}>{formatDateInDMY(billingActive?.serviceStartDate)}
                                    {
                                      CAN(Action.CREATE_BILLING, Resource.D2C_DEMANDS) &&
                                      demandDetailFromStore.actionStatus === ACTION_STATUS.BILLING_ONBOARDING_COMPLETED &&
                                      billingActive?.canEditServiceActivationDate == true && billingActive?.canConfirmServiceActivationDate == false && (
                                        <img
                                          src={IMAGES.editIcon}
                                          className={styles.editIcon}
                                          onClick={() => {
                                            setIsEditServiceDate(true)
                                          }}
                                        />
                                      )
                                    }
                                  </div>
                                </>
                            }
                          </div>
                        }
                      </div>
                    )
                  }
                  {
                    demandDetailFromStore?.actionStatus === ACTION_STATUS.BILLING_INITIATED &&
                    CAN(Action.CREATE_BILLING, Resource.D2C_DEMANDS) && (
                        <div className={styles.actionContainer}>
                          <Billing
                            handelServiceDetailapi={handelServiceDetailapi}
                            actionStatus={ACTION_STATUS.BILLING_INITIATED}
                            billingData={billingActive}
                            isEditServiceDate={false}
                            onToggleScreen={() =>{}}
                          />
                        </div>
                    )
                  }
                  {
                    demandDetailFromStore.actionStatus === ACTION_STATUS.BILLING_ONBOARDING_COMPLETED &&
                    CAN(Action.COMPLETE_DEMAND, Resource.D2C_DEMANDS) && billingActive?.canEditServiceActivationDate == false && billingActive?.canConfirmServiceActivationDate == true &&(
                      <div className={styles.actionContainer}>
                        <div className={styles.actions}>
                          <Submit onClick={() => handleSend("serviceActivationDateAcknowledge")} style={styles.headlesend} isSubmitting={isSubmit === "serviceActivationDateAcknowledge"} title={"Complete Demand"} />
                        </div>
                      </div>
                    )
                  }
                </>
              )
            }
            {
            selectedStage == WORKFLOW_STAGES.ORDER_FORM && (
            <>
              {
                demandDetailFromStore.actionStatus === ACTION_STATUS.ORDER_FORM_LEGAL_CONTRACT_SENT && CAN(Action.SERVICE_PROVISIONING_INITIATOR, Resource.D2C_DEMANDS) &&
                <div className={styles.serviceBuildingContainer}>
                  <div className={styles.serviceBuildingtxt}>
                    Please use this section to initiate the 'Service Build' stage and begin actual service implementation.
                    <br />
                    Click the 'Send for Service Building' button to initiate the process and notify the engineering team to proceed.
                  </div>
                  <div className={styles.actions}>
                    <Submit onClick={() => handleSend("serviceBuilding")} style={styles.headlesend} isSubmitting={isSubmit === "serviceBuilding"} title={"Send for Service Building"} /></div>
                </div>
              }
              </>
             )}
            {
              (
                (selectedStage == WORKFLOW_STAGES.ORDER_FORM && demandDetailFromStore.actionStatus === ACTION_STATUS.ORDER_FORM_LEGAL_CONTRACT_SENT) ||
                [
                  WORKFLOW_STAGES.SERVICE_BUILDING,
                  WORKFLOW_STAGES.BILLING_ONBOARDING,
                  WORKFLOW_STAGES.GO_LIVE
                ].includes(selectedStage)
              ) &&
              ![
                ACTION_STATUS.DEMAND_CLOSED,
                ACTION_STATUS.DEMAND_CLOSED_BY_SYSTEM
              ].includes(demandDetailFromStore.actionStatus)
              && !isEmptyObject(orderFormLegalContractActive) &&
              orderFormLegalContractActive.isLegalContractUploaded === false &&
              orderFormLegalContractActive.isContractSentToLegalTeam == EMAIL_DELIVERY_STATUS.SENT &&
              CAN(Action.UPLOAD_ORDERFORM_LEAGAL_CONTARCT_ATTACHMENT, Resource.D2C_DEMANDS) &&
              <LegalContract
                addDemandAction={props.addDemandAction}
                getServiceDetail={props.getServiceDetail}
                handelServiceDetailapi={handelServiceDetailapi}
              />
            }
            {
              (
                (selectedStage == WORKFLOW_STAGES.ORDER_FORM && demandDetailFromStore.actionStatus === ACTION_STATUS.ORDER_FORM_CUSTOMER_SIGNED_COPY_UPLOADED) ||
                [
                  WORKFLOW_STAGES.SERVICE_BUILDING,
                  WORKFLOW_STAGES.BILLING_ONBOARDING,
                  WORKFLOW_STAGES.GO_LIVE
                ].includes(selectedStage)
              ) &&
              ![
                ACTION_STATUS.DEMAND_CLOSED,
                ACTION_STATUS.DEMAND_CLOSED_BY_SYSTEM
              ].includes(demandDetailFromStore.actionStatus)
              && (isEmptyObject(orderFormLegalContractActive) || (!isEmptyObject(orderFormLegalContractActive) &&
                orderFormLegalContractActive?.isContractSentToLegalTeam == EMAIL_DELIVERY_STATUS.FAILED)) &&
              CAN(Action.TRIGGER_ORDERFORM_CONTACT_EMAIL, Resource.D2C_DEMANDS) &&
              <EmailTrigger requestId={requestId} handelServiceDetailapi={handelServiceDetailapi} emailDeliveryStatus={orderFormLegalContractActive?.isContractSentToLegalTeam} orderFormDocUniqueId={orderFormActiveData?.orderFormDocUniqueId} />
            }
            {
              selectedStage == WORKFLOW_STAGES.ORDER_FORM && (
                <>
                  {/* {
                    demandDetailFromStore.actionStatus === ACTION_STATUS.ORDER_FORM_LEGAL_CONTRACT_SENT && CAN(Action.SERVICE_PROVISIONING_INITIATOR, Resource.D2C_DEMANDS) &&
                    <div className={styles.serviceBuildingContainer}>
                      <div className={styles.serviceBuildingtxt}>
                        Please use this section to initiate the 'Service Build' stage and begin actual service implementation.
                        <br />
                        Click the 'Send for Service Building' button to initiate the process and notify the engineering team to proceed.
                      </div>
                      <div className={styles.actions}>
                        <Submit onClick={() => handleSend("serviceBuilding")} style={styles.headlesend} isSubmitting={isSubmit === "serviceBuilding"} title={"Send for Service Building"} /></div>
                    </div>
                  } */}
                  {
                    !isEmptyObject(orderFormActiveData) &&
                      (CAN(Action.CREATE_DRAFT_ORDER_FORM, Resource.D2C_DEMANDS) || CAN(Action.GET_DRAFT_ORDER_DETAILS, Resource.D2C_DEMANDS)) ?
                      <OrderForm
                        demandDetail={demandDetailFromStore}
                        handelServiceDetailapi={handelServiceDetailapi}
                        orderFormData={orderFormActiveData} 
                        onFileDownload={onFileDownload}/>
                      : <></>
                  }
                </>
              )
            }
            {
              selectedStage == WORKFLOW_STAGES.SERVICE_BUILDING && (
                <>
                  {
                    !isEmptyObject(serviceProvisioningActive) &&
                    CAN(Action.GET_SERVICE_PROVISIONING_DETAILS, Resource.D2C_DEMANDS) &&
                    <ReportIndicatorPanel
                      text={"Please click the 'Download' button to review the attached RFS document."}
                      type={null}
                      data={serviceProvisioningActive}
                      onFileDownload={onFileDownload}
                      downloadAccess={CAN(Action.DOWNLOAD_SERVICE_PROVISIONING, Resource.D2C_DEMANDS)}
                    />
                  }
                  {
                    demandDetailFromStore?.actionStatus === ACTION_STATUS.PROVSIONING_INITIATED && CAN(Action.CREATE_SERVICE_PROVISIONING, Resource.D2C_DEMANDS) &&
                    <ServiceProvisioning handelServiceDetailapi={handelServiceDetailapi} />
                  }
                </>
              )
            }
            {/* {
              selectedStage == WORKFLOW_STAGES.BILLING_ONBOARDING && (
                <>
                  {
                    !isEmptyObject(billingActive) &&
                    billingActive?.serviceStartDate &&
                    CAN(Action.GET_BILLING_DETAILS, Resource.D2C_DEMANDS) && (
                      <div className={styles.actionContainer}>
                         {props?.myRights?.userType === USER_TYPE.CUSTOMER ?
                          <div className={styles.acknowledgeContainer}>
                            {demandDetailFromStore?.actionStatus === ACTION_STATUS.DEMAND_COMPLETED? <div className={`${styles.acktxt} ${styles.stardate}`}>The confirmed 'Service Start Date' is:</div>:<>
                            <div className={`${styles.acktxt} ${styles.stardate}`}>The 'Service Start Date' proposed by the Vodafone team is shown below -</div>
                            <div  className={`${styles.acksubtxt} `}>Please confirm the service start date below. Billing will begin from this date upon confirmation.
                              <br />If no response is received, the service will go live automatically after 10 days.</div>
                            <div className={styles.ackdate}>{billingActive?.serviceStartDate}</div></>}
                          </div> :
                          <div className={styles.acknowledgeContainer}>
                            <div className={`${styles.acktxt} ${styles.stardate}`}>{demandDetailFromStore?.actionStatus === ACTION_STATUS.DEMAND_COMPLETED?"The confirmed 'Service Start Date' is:":"Awaiting customer confirmation of the 'Service Start Date' below:"}</div>
                            <div className={styles.ackdate}>{billingActive?.serviceStartDate}</div>
                          </div>}
                      </div>
                    )
                  }
                  {
                    demandDetailFromStore?.actionStatus === ACTION_STATUS.BILLING_INITIATED &&
                    CAN(Action.CREATE_BILLING, Resource.D2C_DEMANDS) && (
                      <Billing handelServiceDetailapi={handelServiceDetailapi} />
                    )
                  }
                  {
                    demandDetailFromStore.actionStatus === ACTION_STATUS.BILLING_ONBOARDING_COMPLETED &&
                    CAN(Action.COMPLETE_DEMAND, Resource.D2C_DEMANDS) && (
                      <div className={styles.actionContainer}>
                        <div className={styles.actions}>
                          <Submit onClick={() => handleSend("serviceActivationDateAcknowledge")} style={styles.headlesend} isSubmitting={isSubmit === "serviceActivationDateAcknowledge"} title={"Confirm"} />
                        </div>
                      </div>
                    )
                  }
                </>
              )
            } */}
            {
              selectedStage == WORKFLOW_STAGES.GO_LIVE && (
                <>
                  {
                    !isEmptyObject(billingActive) &&
                    CAN(Action.GET_BILLING_DETAILS, Resource.D2C_DEMANDS) && (
                      <div className={styles.actionContainer}>
                       {props?.myRights?.userType === USER_TYPE.CUSTOMER ?
                          <div className={styles.acknowledgeContainer}>
                            <div className={`${styles.acktxt} ${styles.stardate}`}>The confirmed 'Service Start Date' is:</div>
                            <div className={styles.ackdate}>{formatDateInDMY(billingActive?.serviceStartDate)}</div>
                          </div> :
                          <div className={styles.acknowledgeContainer}>
                            <div className={`${styles.acktxt} ${styles.stardate}`}>The confirmed 'Service Start Date' is:</div>
                            <div className={styles.ackdate}>{formatDateInDMY(billingActive?.serviceStartDate)}</div>
                          </div>}
                      </div>
                    )
                  }
                </>
              )
            }
          </div>
          {demandClosure && (
            <DemandClosurePopup
              type={demandClosure}
              onClose={() => setDemandClosure(false)}
              openAlertPopup={props.openAlertPopup}
              addDemandAction={props.addDemandAction}
              getServiceDetail={handelServiceDetailapi}
              setDemandClosure={setDemandClosure}
            />
          )}
          <div ref={targetRef}>
             {(
                CAN(Action.CREATE_COMMENT, Resource.DEMANDS) ||  CAN(Action.GET_COMMENT, Resource.DEMANDS) ||  CAN(Action.LIST_ACTIVITY, Resource.D2C_DEMANDS) || 
                demandDetailFromStore.actionStatus == ACTION_STATUS.FEASIBILITY_INITIATED && CAN(Action.CREATE_FEASIBILITY_COMMENTS, Resource.D2C_DEMANDS) ||
                demandDetailFromStore.actionStatus == ACTION_STATUS.PROVSIONING_INITIATED && CAN(Action.CREATE_PROVISIONING_COMMENTS, Resource.D2C_DEMANDS) ||
                CAN(Action.GET_FEASIBILITY_COMMENT, Resource.D2C_DEMANDS) ||  CAN(Action.GET_PROVISIONING_COMMENT, Resource.D2C_DEMANDS)         
              ) &&(
            <AddComment
              onFileDownload={onFileDownload}
              actionStatus={demandDetailFromStore.actionStatus}
              isActiveDemand={isActiveDemand}
              setActiveTab={setActiveTab}
              activeTab={activeTab}
            />)}
          </div>

        </Container>
      </SectionGuard>
  )
}

export default DemandDetail;